import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useFirewallPoliciesStatusData } from '../../hooks/useFirewallPoliciesStatusData';
import ServicesStatus from '../ServicesStatus/ServicesStatus';

export default memo(function FirewallPoliciesStatus(props) {
    const [t] = useTranslation('dashboard');

    useFirewallPoliciesStatusData(props.getFirewallPoliciesStatusRequest);

    return <ServicesStatus
        description={t('dashboard:firewall_policies_detail')}
        error={props.firewallPolicies.error}
        fetching={props.firewallPolicies.fetching}
        services={props.firewallPolicies.status}
        title={t('dashboard:firewall_policies')}
    />;
}, (prevProps, nextProps) =>
        prevProps.firewallPolicies === nextProps.firewallPolicies &&
        prevProps.getFirewallPoliciesStatusRequest === nextProps.getFirewallPoliciesStatusRequest
);
